const CloseCircle = () => {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="50" height="50" rx="25" transform="matrix(-1 0 0 1 50 0)" fill="#FAFAFA" />
      <path d="M18 18L32 32M32 18L18 32" stroke="#33363F" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default CloseCircle;
